import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getPowerGenerationSourceList as getPowerGenerationSourceListApi,
	getPowerGenerationSource as getPowerGenerationSourceApi,
	addNewPowerGenerationSource as addNewPowerGenerationSourceApi,
	updatePowerGenerationSource as updatePowerGenerationSourceApi,
	deletePowerGenerationSource as deletePowerGenerationSourceApi,
	getPowerGenerationHourMeterSummaryQuery as getPowerGenerationHourMeterSummaryQueryApi,
	getPowerGenerationDailyConsumptionQuery as getPowerGenerationDailyConsumptionQueryApi,
} from '../../helpers/establishment/backend_helper';

export const getPowerGenerationSourceList = createAsyncThunk('powerGenerationSource/getPowerGenerationSourceList', async (params) => {
	try {
		const response = getPowerGenerationSourceListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getPowerGenerationSource = createAsyncThunk('powerGenerationSource/getPowerGenerationSource', async powerGenerationSource_id => {
	try {
		const response = getPowerGenerationSourceApi(powerGenerationSource_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewPowerGenerationSource = createAsyncThunk('powerGenerationSource/addNewPowerGenerationSource', async powerGenerationSource => {
	try {
		const response = addNewPowerGenerationSourceApi(powerGenerationSource);
		toast.success('Fuente de Generación de Energía agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar powerGenerationSource.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updatePowerGenerationSource = createAsyncThunk('powerGenerationSource/updatePowerGenerationSource', async (powerGenerationSource) => {
		try {
			const response = updatePowerGenerationSourceApi(powerGenerationSource);
			toast.success('Fuente de Generación de Energía actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar powerGenerationSource.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deletePowerGenerationSource = createAsyncThunk('powerGenerationSource/deletePowerGenerationSource', async powerGenerationSource => {
	try {
		const response = await deletePowerGenerationSourceApi(powerGenerationSource);
		toast.success('Fuente de Generación de Energía eliminado exitosamente.', { autoClose: 3000 });
		return { powerGenerationSource, ...response };
	} catch (error) {
		toast.error('Error al eliminar powerGenerationSource.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const getPowerGenerationHourMeterSummaryQuery = createAsyncThunk(
	'powerGenerationSource/getPowerGenerationHourMeterSummaryQuery',
	async params => {
		try {
			const response = getPowerGenerationHourMeterSummaryQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getPowerGenerationDailyConsumptionQuery = createAsyncThunk(
	'powerGenerationSource/getPowerGenerationDailyConsumptionQuery',
	async params => {
		try {
			const response = getPowerGenerationDailyConsumptionQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);


